
export default function Expense() {

    return (
        <div className="p-3">
            <h3 className="font-bold">Expense</h3>
        </div>
    )
}